<template>
<div class="wrapper" :style="{width: size ? size + 'px' : '90px', height: size ? size + 'px' : '90px'}">
  <!--if an image is provided. Vue can't seem to compile relative paths in conditional javascript, so we create two elements-->
  <span class="uk-badge badge" v-if="badge && badge != 0">{{badge}}</span>
  <img
          v-if="image"
          class="uk-border-circle"
          :src="image"
          :height="size || 90"
          :width="size || 90"
  />

  <!--if image is not provided-->


    <img
          v-if="!image"
          class="uk-border-circle"
          src="../../assets/images/anonymous-user.png"
          :height="size || 90"
          :width="size || 90"
  />

</div>

</template>

<script>
	export default {
		name: "Avatar",
    props: ["image", "size", "badge"],

	}
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";

  .wrapper {
    position: relative;
  }

  img {
    border: 2px solid @primary-1;
    position: relative;
  }

  .badge {
    position: absolute;
    top: 0px;
    right: 0px;

  }

</style>
